import { render, staticRenderFns } from "./is-saved.vue?vue&type=template&id=1a051e44&scoped=true&"
import script from "./is-saved.vue?vue&type=script&lang=js&"
export * from "./is-saved.vue?vue&type=script&lang=js&"
import style0 from "./is-saved.vue?vue&type=style&index=0&id=1a051e44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a051e44",
  null
  
)

export default component.exports